module.exports = __webpack_public_path__ + "media/images/signup-scott-faust-16d3abdd75fa90668c59568784e9d016.jpg";